import { PlayerStates } from 'data/VideoPlayer'
import LiveVideo from 'components/set/InteractionPlayer/LiveVideo/LiveVideo'
import React from 'react'
import { Show } from 'data/Show'
import { Pass } from 'data/Pass'
import { Unpopulated } from 'data/Populated'

interface LiveStreamActiveProps {
    show: Show
    muted: boolean
    passList: Unpopulated<Pass, 'show'>[]
}

export const LiveStreamActive: React.FC<LiveStreamActiveProps> = ({ show, muted, passList }) => (
    <LiveVideo passList={passList} show={show} muted={muted} stateId={`${PlayerStates.LIVE}_active`} />
)

export default React.memo(LiveStreamActive)
